import { getAllUsers, getUsersFromGroup } from 'admin/users/modules/users';

export function fetchUsers({ selectedGroup, searchTerm = '' }) {
  if (selectedGroup && selectedGroup.id !== 'all') {
    return getUsersFromGroup(selectedGroup.id, searchTerm);
  } else {
    return getAllUsers(searchTerm);
  }
}
